import type { LaunchContext } from "./LaunchContextTypes";
import type { ScreenShapeHint } from "@slot/presentation";

/** The device the launch context names: the channel first, then the client type; null when it names none. */
export function shapeHintFromLaunchContext(launchContext: LaunchContext | null): ScreenShapeHint {
  if (!launchContext) return null;
  if (launchContext.channel === "desktop" || launchContext.channel === "mobile") return launchContext.channel;
  if (launchContext.clientType === "desktop" || launchContext.clientType === "mobile") return launchContext.clientType;
  return null;
}
